import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-price',
  templateUrl: './price.component.html',
})
export class PriceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
